
<!-- Header that allows for selecting the Infrastructure subpage to be on -->
<app-infrastructure-header [title]='"DEVICES"'></app-infrastructure-header>

<!-- Main Screen which shows the Device Objects and Device Instances -->
<div style="clear: both" id="objectContentPane">
	<div style="margin: 12px">

		<!-- Tab Navigation Control -->
		<ul class="nav nav-tabs">
			<li class="active"><a data-toggle="tab" href="#device-instances-tab" aria-expanded="true"><i class="fa fa-star-o"></i> DEVICES</a></li>
			<li class=""><a data-toggle="tab" href="#device-objects-tab" aria-expanded="false"><i class="fa fa-star-o"></i> DEVICE TYPES</a></li>
		</ul>

		<!-- Tab Content -->
		<div class="tab-content">

			<!-- Device Objects Tab -->
			<div id="device-objects-tab" class="tab-pane fade">

				<!-- Add Device Type and Options buttons -->
				<button (click)="addDeviceClicked()" type="button" class="btn btn-ef"><em class="fa fa-plus"></em> ADD
					DEVICE TYPE</button>
				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown"><em
							class="fa fa-th"></em> OPTIONS <span class="caret"></span></button>
					<ul class="dropdown-menu">
						<li (click)="editSelectedDeviceClicked()" [class.disabled]="!isSingleDeviceObjectSelected()">
							<a><em class="fa fa-pencil"></em> EDIT</a>
						</li>
						<li (click)="duplicateSelectedDeviceClicked()"
							[class.disabled]="!isSingleDeviceObjectSelected()"><a><em class="fa fa-clone"></em>
								DUPLICATE</a></li>
						<li (click)="deleteSelectedDevicesClicked()" [class.disabled]="!isAnyDeviceObjectsSelected()">
							<a><em class="fa fa-remove"></em> DELETE</a>
						</li>
						<li class="divider"></li>
						<li (click)="addSelectedDeviceObjectsToGroupClicked()"
							[class.disabled]="!isAnyDeviceObjectsSelected()"><a><em class="fa fa-plus"></em> ADD TO
								GROUP</a></li>
						<li (click)="removeSelectedDeviceObjectsFromGroupClicked()"
							[class.disabled]="!isAnyDeviceObjectsSelected()"><a><em class="fa fa-remove"></em> REMOVE
								FROM GROUP</a></li>
						<li (click)="manageDeviceObjectGroupsClicked()"><a><em class="fa fa-pencil"></em> MANAGE
								GROUPS</a></li>
						<li class="divider"></li>>
						<li (click)="uploadTypeFileClicked()"><input type="file" #typeFileUpload
								(change)="onTypeFileUploadChange($event)" style="display:none" /><a><em
									class="fa fa-upload"></em> UPLOAD TYPES </a></li>
						<li (click)="downloadTypes()"><a><em class="fa fa-download"></em> DOWNLOAD TYPES </a></li>
						<li (click)="downloadDevices()" [class.disabled]="!isSingleDeviceObjectSelected()"><a><em
									class="fa fa-download"></em> DOWNLOAD DEVICES </a></li>
						
					</ul>
				</div>

				<!-- Filter (dropdown + type-aware value input) -->
			<app-filter-bar
				[options]="filterOptionsForTypes"
				[(selected)]="filterOptionForTypes"
				(filterChanged)="onTypesFilterChanged($event)">
			</app-filter-bar>

			<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
				<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown"><em
						class="fa fa-bars"></em> RESULTS PER PAGE <span class="caret"></span></button>
						<ul class="dropdown-menu">
							<li *ngFor="let value of resultsPerPageValues" (click)="manageResultPerPageClickedForTypes(value)" [class.active]="value === selectedPageSizeValueForTypes">
								<a>{{ value }}</a>
							</li>
						</ul>
			</div>

				<!-- Device Objects -->
				<table class="table tablesorter tablesorter-default table-bordered table-hover" data-toggle="table"
					data-id-field="userid" role="grid">
					<thead>
						<tr role="row" class="tablesorter-headerRow">
							<th data-column="0" class="tablesorter-header tablesorter-headerUnSorted" tabindex="0"
								scope="col" role="columnheader" aria-disabled="false" aria-controls="table1"
								aria-sort="none" aria-label=": No sort applied, activate to apply an ascending sort"
								style="user-select: none;">
								<div class="tablesorter-header-inner">
									<input type="checkbox" [checked]="isAllDeviceObjectsSelected()"
										(change)="setAllDeviceObjectsSelected($event)" />
								</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="name" data-sortable="true" data-column="1" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table1" aria-sort="none"
								aria-label="Name: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner">Name</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="groups" data-sortable="true" data-column="2" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table1" aria-sort="none"
								aria-label="Groups: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner">Groups</div>
							</th>
						</tr>
					</thead>
					<tbody aria-live="polite" aria-relevant="all">
						<ng-container
							*ngFor="let deviceObject of mDeviceObjects | paginate: {id: 'deviceobjects_pagination', itemsPerPage: selectedPageSizeValueForTypes, currentPage: currentPageForTypes, totalItems: totalNumberOfTypes }">
							<tr class="" role="row">
								<td><input type="checkbox" [(ngModel)]="deviceObject.mSelected" /></td>
								<td (click)="editDevice(deviceObject.mDevice)">{{deviceObject.mDevice.name}}</td>
								<td>
									<ng-container
										*ngIf="deviceObject.mDevice.groups != null && deviceObject.mDevice.groups.length > 0">
										<ng-container *ngFor="let group of deviceObject.mDevice.groups">
											<button class="groupButton"
												(click)="showGroup(group)">{{group.name}}</button>
										</ng-container>
									</ng-container>
								</td>
							</tr>
						</ng-container>
					</tbody>
				</table>

				<!-- Pagination Controls for the "Devices" Types (controls referenced in the *ngFor for the table data above) -->
				<pagination-controls class="pagination" id="deviceobjects_pagination" (pageChange)="onTypePageChange($event)"
					[directionLinks]="true" nextLabel="Next" previousLabel="Prev" [autoHide]="true">
				</pagination-controls>

			</div>

			<!-- Device Instances Tab -->
			<div id="device-instances-tab" class="tab-pane fade active in">

				<!-- Add Device and Options buttons -->
				<button (click)="addDeviceInstanceClicked()" type="button" class="btn btn-ef"><em
						class="fa fa-plus"></em> ADD DEVICE</button>
				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown"><em
							class="fa fa-th"></em> OPTIONS <span class="caret"></span></button>
					<ul class="dropdown-menu">
						<li (click)="editSelectedDeviceInstanceClicked()"
							[class.disabled]="!isSingleDeviceInstanceSelected()"><a><em class="fa fa-pencil"></em>
								EDIT</a></li>
						<li (click)="duplicateSelectedDeviceInstanceClicked()"
							[class.disabled]="!isSingleDeviceInstanceSelected()"><a><em class="fa fa-clone"></em>
								DUPLICATE</a></li>
						<li (click)="deleteSelectedDeviceInstancesClicked()"
							[class.disabled]="!isAnyDeviceInstancesSelected()"><a><em class="fa fa-remove"></em>
								DELETE</a></li>
						<li class="divider"></li>
						<li (click)="addSelectedDeviceInstancesToGroupClicked()"
							[class.disabled]="!isAnyDeviceInstancesSelected()"><a><em class="fa fa-plus"></em> ADD TO
								GROUP</a></li>
						<li (click)="removeSelectedDeviceInstancesFromGroupClicked()"
							[class.disabled]="!isAnyDeviceInstancesSelected()"><a><em class="fa fa-remove"></em> REMOVE
								FROM GROUP</a></li>
						<li (click)="manageDeviceInstanceGroupsClicked()"><a><em class="fa fa-pencil"></em> MANAGE
								GROUPS</a></li>
						<li class="divider"></li>
						<li (click)="uploadInstanceFileClicked()"><input type="file" #fileInstanceUpload
								(change)="onInstanceFileUploadChange($event)" style="display:none" /><a><em
									class="fa fa-upload"></em> UPLOAD DEVICES </a></li>

					</ul>
				</div>

				<!-- Filter (dropdown + type-aware value input) -->
				<app-filter-bar
					[options]="filterOptionsForInstances"
					[multiple]="true" [(active)]="activeFilterOptionsForInstances"
					(filterChanged)="onInstancesFilterChanged($event)">
				</app-filter-bar>

				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown"><em
							class="fa fa-bars"></em> RESULTS PER PAGE <span class="caret"></span></button>
							<ul class="dropdown-menu">
								<li *ngFor="let value of resultsPerPageValues" (click)="manageResultPerPageClickedForInstances(value)" [class.active]="value === selectedPageSizeValueForInstances">
									<a>{{ value }}</a>
								</li>
							</ul>
				</div>


				<!-- Device Instances -->
				<table class="table tablesorter tablesorter-default table-bordered table-hover" data-toggle="table"
					data-id-field="userid" role="grid">
					<thead>
						<tr role="row" class="tablesorter-headerRow">
							<th data-column="0" class="tablesorter-header tablesorter-headerUnSorted" tabindex="0"
								scope="col" role="columnheader" aria-disabled="false" aria-controls="table2"
								aria-sort="none" aria-label=": No sort applied, activate to apply an ascending sort"
								style="user-select: none;">
								<div class="tablesorter-header-inner">
									<input type="checkbox" [checked]="isAllDeviceInstancesSelected()"
										(change)="setAllDeviceInstancesSelected($event)" />
								</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="name" data-sortable="true" data-column="1" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table2" aria-sort="none"
								aria-label="Name: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner">Name</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="object" data-sortable="true" data-column="2" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table2" aria-sort="none"
								aria-label="Asset Type: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner">Device Type</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="groups" data-sortable="true" data-column="3" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table2" aria-sort="none"
								aria-label="Groups: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner">Groups</div>
							</th>
						</tr>
					</thead>
					<tbody aria-live="polite" aria-relevant="all">
						<ng-container
							*ngFor="let deviceInstance of mDeviceInstances | paginate: {id: 'deviceinstance_pagination', itemsPerPage: selectedPageSizeValueForInstances, currentPage: currentPageForInstances, totalItems: totalNumberOfInstances }">
							<tr class="" role="row">
								<td><input type="checkbox" [(ngModel)]="deviceInstance.mSelected" /></td>
								<td (click)="editDeviceInstance(deviceInstance.mDeviceInstance)"  (contextmenu)="fetchFunctionList($event, deviceInstance.mDeviceInstance)">
									{{deviceInstance.mDeviceInstance.name}}</td>
								<td (click)="editDeviceInstance(deviceInstance.mDeviceInstance)">
									{{deviceInstance.mDeviceInstance.object.name}}</td>
								<td>
									<ng-container
										*ngIf="deviceInstance.mDeviceInstance.groups != null && deviceInstance.mDeviceInstance.groups.length > 0">
										<ng-container *ngFor="let group of deviceInstance.mDeviceInstance.groups">
											<button class="groupButton"
												(click)="showGroup(group)">{{group.name}}</button>
										</ng-container>
									</ng-container>
								</td>
							</tr>
						</ng-container>
					</tbody>
				</table>

				<!-- Pagination Controls for the "Device" Instance (controls referenced in the *ngFor for the table data above) -->
			<pagination-controls class="pagination" id="deviceinstance_pagination"
			(pageChange)="onInstancePageChange($event)" [directionLinks]="true"
			nextLabel="Next" previousLabel="Prev" [autoHide]="true">
		</pagination-controls>

			</div>
		</div>
	</div>
</div>

<app-entity-type-dialog #entityTypeDialog [entity]="mEntity" [entityName]="mEntityName" [entityType]="mEntityType"
	[entityTypeName]="mEntityTypeName" (createOrUpdateEvent)="createOrUpdateEntityType()"
	(showGroup)="showGroup($event)">
</app-entity-type-dialog>

<app-entity-instance-dialog #entityInstanceDialog [instance]="mInstance" 
	[instanceName]="mInstanceName" [instanceEntityType]="mInstanceEntityType" [instanceType]="mInstanceType"
	[instanceTypeName]="mInstanceTypeName" [availableEntityTypes]="mAvailableEntityTypes"
	(createOrUpdateEvent)="createOrUpdateEntityInstance()" (showGroup)="showGroup($event)"
	(selectedEntityTypeChangedEvent)="selectedEntityTypeChanged($event)"
	(refreshInstanceDataEvent)="refreshInstanceData()">
</app-entity-instance-dialog>

<app-confirm-delete-dialog #confirmDeleteDialog (confirmEvent)="deleteConfirmed()"></app-confirm-delete-dialog>
<app-show-group-dialog #showGroupDialog></app-show-group-dialog>
<app-manage-groups-dialog #manageGroupsDialog></app-manage-groups-dialog>
<app-add-to-group-dialog #addToGroupDialog (confirmEvent)="addSelectedToGroup($event)"></app-add-to-group-dialog>
<app-remove-from-group-dialog #removeFromGroupDialog (confirmEvent)="removeSelectedFromGroup($event)">
</app-remove-from-group-dialog>

<!-- Right Click dropdown menu -->
<app-dropdown-menu *ngIf="showContextMenu" [x]="contextMenuPosition.x" [y]="contextMenuPosition.y"
	[items]="functionList" (selectedItemChange)="onItemClicked($event)"></app-dropdown-menu>

<!-- Going further if we want to display the function execution status
	<app-function-executing-dialog  #functionExecutingDialog (functionExecutionStartEvent)="functionStartingToExecute($event)" (functionExecutionSuccessEvent)="functionFinishedExecutingSuccessfully()" (functionExecutionErrorEvent)="functionFinishedExecutingWithError($event)"></app-function-executing-dialog> -->

<app-general-function-dialog *ngIf="showGeneralDialog" #generalDialog [instance]="mInstance" [instanceType]="mInstanceType"
	[function]="selectedFunction"></app-general-function-dialog>

<!-- Simple Success Error Dialog Box - Displaying the Error generated for now since we dont display success msgs -->
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>